import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import React from 'react';
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import HomeJP from "./pages/Home_jp";
import ContactJP from "./pages/Contact_jp";
import AboutJP from "./pages/About_jp";
import HomeFR from "./pages/Home_fr";
import ContactFR from "./pages/Contact_fr";
import AboutFR from "./pages/About_fr";
import FAQ from "./pages/FAQ";
import FAQJP from "./pages/FAQ_jp";
import FAQFR from "./pages/FAQ_fr";
import Testimonials from "./pages/Testimonials";
import TestimonialsJP from "./pages/Testimonials_jp";
import TestimonialsFR from "./pages/Testimonials_fr";
import { Toaster } from "./components/ui/sonner";
import { Analytics } from "@vercel/analytics/react";

const LangGuard = ({ Component, ComponentJP, ComponentFR }) => {
  const { lang } = useParams();
  if (lang !== 'en' && lang !== 'ja' && lang !== 'fr') {
    return <Navigate to="/en" replace />;
  }
  if (lang === 'ja' && ComponentJP) {
    return <ComponentJP />;
  }
  if (lang === 'fr' && ComponentFR) {
    return <ComponentFR />;
  }
  return <Component />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/en" replace />} />
          <Route path="/:lang" element={<LangGuard Component={Home} ComponentJP={HomeJP} ComponentFR={HomeFR} />} />
          <Route path="/:lang/contact" element={<LangGuard Component={Contact} ComponentJP={ContactJP} ComponentFR={ContactFR} />} />
          <Route path="/:lang/about" element={<LangGuard Component={About} ComponentJP={AboutJP} ComponentFR={AboutFR} />} />
          <Route path="/:lang/faq" element={<LangGuard Component={FAQ} ComponentJP={FAQJP} ComponentFR={FAQFR} />} />
          <Route path="/:lang/testimonials" element={<LangGuard Component={Testimonials} ComponentJP={TestimonialsJP} ComponentFR={TestimonialsFR} />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <Analytics />
    </div>
  );
}

export default App;
